export var ACTIVE_ROUTE_CLASS = 'active';
export var PROPS_TO_OMIT = ['large', 'nonFocusable', 'active', 'activeClassName', 'darkBackground', 'roundedStyle'];
export var E2E_MENU_ITEM_SUFFIX = '-menu-item';